import { INTERNAL_PATHS } from "routes/paths";

export const LINK_LIST = {
  desktop: [
    { label: "Brand Restrictions", url: INTERNAL_PATHS.BRAND_RESTRICTIONS },
    { label: "90 Day Money-Back Guarantee", url: INTERNAL_PATHS.GUARANTEE },
    { label: "FTC Disclosure", url: INTERNAL_PATHS.FTC_DISCLOSURE }
  ],
  default: [
    { label: "How It Works", url: INTERNAL_PATHS.HOW_IT_WORKS },
    { label: "Refer and Earn $5", url: INTERNAL_PATHS.REFERRAL_PROGRAM },
    { label: "Gift Card Balance", url: INTERNAL_PATHS.GIFT_CARD_BALANCE },
    { label: "Shipping & Delivery", url: INTERNAL_PATHS.SHIPPING_POLICY },
    { label: "Privacy Policy", url: INTERNAL_PATHS.PRIVACY_POLICY }
  ]
};
